/**
 * Google Tag Manager (GTM) event constants
 * This file contains predefined event names for use with the pushGTMEvent function
 */

export const GTM_EVENTS = {
  USER_LOGIN: 'user_login',
  USER_REGISTRATION: 'user_registration',
  USER_LOGOUT: 'user_logout',
  USER_DEPOSIT: 'user_deposit',
  USER_WITHDRAWAL: 'user_withdrawal',
  GAME_START: 'game_start'
}

export const GTM_SIGN_OUT_REASON = {
  FROM_USER: 'from_user',
  FROM_PHONE_VERIFICATION: 'from_phone_verification',
  FROM_ACCOUNT_PAGE: 'from_account_page',
  ON_UPDATING_LIMITS: 'on_updating_limits'
}
